import { useEffect, useState } from "react";
import Header from "./components/Header";
import Hero from "./components/Hero";
import Feed from "./components/Feed";
import TopList from "./components/TopList";
import Awkward from "./components/Awkward";
import Quotes from "./components/Quotes";
import Reviews from "./components/Reviews";
import FAQ from "./components/FAQ";
import Footer from "./components/Footer";

export default function Home() {
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 500);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div className="min-h-screen bg-orange-50/60 text-stone-900">
      <Header />
      <main>
        <Hero />
        <Feed />
        <TopList />
        <Awkward />
        <Quotes />
        <Reviews />
        <FAQ />
      </main>
      <Footer />

      <button
        onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
        aria-label="返回顶部"
        className={`fixed bottom-6 right-6 z-40 grid h-12 w-12 place-items-center rounded-full bg-stone-900 text-white shadow-lg transition-all duration-300 hover:bg-orange-500 ${
          showTop ? "translate-y-0 opacity-100" : "pointer-events-none translate-y-4 opacity-0"
        }`}
      >
        <i className="ri-arrow-up-line text-xl" />
      </button>
    </div>
  );
}